import React, { useContext } from "react";
import { useLocation, Link } from "react-router-dom";
import Header from "./Header";
import { ProductContext } from "../context/AppContext";
import { all_routes } from "./router/all_routes";
import {
  FaFileAlt,
  FaUsers,
  FaChartBar,
  FaCog,
  FaBook,
  FaGraduationCap,
  FaMoneyBillWave,
  FaCalendarAlt,
  FaUserGraduate,
  FaSchool,
  FaClipboardList,
  FaBell,
  FaShieldAlt,
  FaCubes,
  FaArrowRight
} from "react-icons/fa";

const Information = () => {
  const location = useLocation();
  const { getMenuList } = useContext(ProductContext);
  const { label, submenuItems } = location.state || {};

  const routes = all_routes;

  const resolveRoute = (link) => {
    if (typeof link === "string" && link.startsWith("routes.")) {
      const routeKey = link.replace("routes.", "");
      return routes[routeKey] || "/";
    }
    return link;
  };

  // ICON MAPPER
  const getIconForLabel = (label) => {
    const iconMap = {
      Academics: FaBook,
      Classes: FaSchool,
      Subjects: FaBook,
      Timetable: FaCalendarAlt,
      Syllabus: FaClipboardList,
      Attendance: FaUserGraduate,
      Students: FaUsers,
      Admissions: FaUserGraduate,
      Registration: FaClipboardList,
      Promotion: FaGraduationCap,
      Finance: FaMoneyBillWave,
      Fees: FaMoneyBillWave,
      Payments: FaMoneyBillWave,
      Expenses: FaMoneyBillWave,
      Examinations: FaChartBar,
      Results: FaChartBar,
      Marks: FaClipboardList,
      Settings: FaCog,
      Administration: FaCog,
      Users: FaUsers,
      Roles: FaShieldAlt,
      Reports: FaChartBar,
      Notifications: FaBell,
      Modules: FaCubes,
      Dashboard: FaChartBar
    };

    const key = Object.keys(iconMap).find((name) =>
      label?.toLowerCase().includes(name.toLowerCase())
    );

    return key ? iconMap[key] : FaFileAlt;
  };

  // COLOR THEMES
  const colorThemes = [
    { bg: "primary", text: "white" },
    { bg: "success", text: "white" },
    { bg: "info", text: "white" },
    { bg: "warning", text: "dark" },
    { bg: "danger", text: "white" },
    { bg: "secondary", text: "white" },
    { bg: "dark", text: "white" },
    { bg: "light", text: "dark" }
  ];

  const getThemeForIndex = (index) => colorThemes[index % colorThemes.length];

  return (
    <>
      <div className="page-wrapper">
        <div className="content min-vh-100">
          <Header />

          {/* HEADER */}
          <div className="container-fluid">
            <div className="row py-4">
              <div className="col-12">
                <div className="info-header">
                  <h2 className="fw-bold text-dark mb-1">{label}</h2>
                  <p className="text-muted mb-0">
                    Explore all {label?.toLowerCase()} modules and features
                  </p>
                </div>
              </div>
            </div>

            {/* GRID */}
            <div className="row">
              <div className="col-12">
                {submenuItems && submenuItems.length > 0 ? (
                  <div className="row g-4">

                    {submenuItems.map((subItem, index) => {
                      const Icon = getIconForLabel(subItem.label);
                      const theme = getThemeForIndex(index);

                      return (
                        <div
                          key={subItem.id}
                          className="col-xl-3 col-lg-4 col-md-6 col-sm-6"
                        >
                          <Link
                            to={
                              subItem.submenuItems?.length > 0
                                ? routes.submenu
                                : resolveRoute(subItem.link)
                            }
                            state={{
                              id: subItem.id,
                              label: subItem.label,
                              submenuItems: subItem.submenuItems
                            }}
                            className="text-decoration-none"
                          >
                            <div className="info-card shadow-sm rounded-4">
  <div className="info-card-body">

    {/* ARROW TOP RIGHT */}
    <div className="info-arrow-top info-arrow-top_2">
      <FaArrowRight
        className={`text-${theme.bg}`}
        size={15}
      />
    </div>

    {/* ICON + TITLE ROW */}
    <div className="d-flex align-items-center gap-3 mt-3">
      <div className={`info-icon bg-${theme.bg} text-${theme.text}`}>
        <Icon size={18} />
      </div>

      <h6 className="info-title-inline mb-0">{subItem.label}</h6>
    </div>

  </div>
</div>

                          </Link>
                        </div>
                      );
                    })}

                  </div>
                ) : (
                  <div className="text-center py-5">
                    <FaFileAlt size={60} className="text-muted opacity-50" />
                    <h4 className="mt-3 text-dark">No Modules Found</h4>
                    <p className="text-muted">
                      There are no modules available under {label}.
                    </p>
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* ---------------- CSS ---------------- */}
      <style jsx="true">{`
        .info-header {
          background: linear-gradient(135deg, #f8f9fa, #e9ecef);
          padding: 20px;
          border-radius: 16px;
        }

        /*************** CARD ***************/
      .info-card {
  background: #fff;
  border-radius: 16px;
  padding: 14px;
  transition: all 0.3s ease;
  cursor: pointer;
  border: none !important;
  min-height: 110px; /* compact tile */
  position: relative;
}

.info-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
}

/* Arrow */
.info-arrow-top {
  position: absolute;
  top: 10px;
  right: 14px;
  transition: all 0.3s ease;
}
.info-card:hover .info-arrow-top {
  transform: translateX(4px);
}

/* Icon */
.info-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.25s ease;
}
.info-card:hover .info-icon {
  transform: scale(1.06);
}

/* Title inline */
.info-title-inline {
  font-size: 1rem;
  font-weight: 600;
  color: #222;
}

/* Mobile */
@media (max-width: 576px) {
  .info-card {
    min-height: 100px;
    padding: 12px;
  }

  .info-icon {
    width: 38px;
    height: 38px;
  }

  .info-title-inline {
    font-size: 0.95rem;
  }
}
      `}</style>
    </>
  );
};

export default Information;
